import type { Role } from "types/roles";

let token: string | null = null;

export function initialiseAuthToken() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.get("token")) {
    localStorage.setItem("token", urlParams.get("token") as string);
    setAuthToken(urlParams.get("token") as string);

    urlParams.delete("token");
    const newUrl = `${window.location.pathname}${
      urlParams.toString() ? `?${urlParams.toString()}` : ""
    }`;
    window.history.replaceState({}, "", newUrl);

    return;
  }
  setAuthToken(localStorage.getItem("token") || null);
}

export function getAuthToken() {
  return token;
}

export function setAuthToken(newToken: string | null) {
  token = newToken;
}

export function getTokenPayload(): {
  sub?: string;
  silo_internal_name?: string;
  exp?: number;
  roles?: Role | Role[];
} | null {
  const token = getAuthToken();
  if (!token) return null;

  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
}

export function isTokenExpired(): boolean {
  const payload = getTokenPayload();
  if (!payload?.exp) return false;
  return payload.exp * 1000 < Date.now();
}

export function getRoleFromToken(): Role | null {
  const roles = getTokenPayload()?.roles;
  if (Array.isArray(roles)) {
    return roles[0] ?? null;
  }
  return roles ?? null;
}
